<mat-toolbar>
  <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div class="hide-print" >
    <span class="hide-mobile">{{adminService.getText('object','capitalize')}} </span>{{vehicle()?.identifier}}
  </div>
</mat-toolbar>

<div class="wrapper" #wrapper>
  @if (loading()) {
    <div class="skeleton-wrapper">
      <div class="skeleton skeleton-info"></div>

      <div class="skeleton skeleton-booking"></div>

      <div class="skeleton skeleton-client"></div>
    </div>
  }
  @if (vehicle() && !loading()) {
    <div class="vehicle">
      <div class="header">
        <div class="title">
          <div class="logo">
            <img [src]="company_logo">
          </div>
        </div>
      </div>
      <div class="content">
          <ng-container>
            <div class="info">
              <div class="name">Marca</div>
              <div class="value">{{vehicle().brand.name || 'No existe el '+adminService.getText('client')}}</div>

              <div class="name">Modelo</div>
              <div class="value">{{vehicle().brand_model.name}}</div>

              <div class="name">Año</div>
              <div class="value">{{vehicle().year || '-'}}</div>
            
              <div class="name">Patente</div>
              <div class="value">{{vehicle().identifier}}</div>
            
              <div class="name">Chasis</div>
              <div class="value">{{vehicle().chasis}}</div>

              <div class="name">Fecha Registro</div>
              <div class="value">{{vehicle().created_at | date: 'shortDate'}}</div>

              <div class="name">Fecha Última Actualización</div>
              <div class="value">{{vehicle().updated_at | date: 'shortDate'}}</div>

              <div class="name">Cliente Actual</div>
              <div class="value">
                @if (vehicle().client) {
                  <span class="link" go-to-details [element]="vehicle().client" type="Client">{{(vehicle().client?.name | titlecase) || '-'}}</span>
                } @else {
                  <span class="no-client">Sin Cliente</span>
                }
              </div>

              
            </div>
          </ng-container>
        

        @if (roleService.can('create', 'booking') | async) {
          <div class="order-card" (click)="createBooking()">
            <div class="icon">
              <i class="fa fa-calendar-plus"></i>
            </div>
            <div class="requirement">
              <div>Agendar vehiculo</div>
            </div>
          </div>
        }

        @if (vehicle().clients.length > 0) {
          <div class="history">
            <div class="subtitle">Historial</div>
            @for (client of vehicle().clients; track client.id) {
                <div class="client">
                  <div class="title" go-to-details [element]="{id: client.id, type: 'Client'}">
                    <div class="title-info">
                      <div class="icon">
                        <i class="fa fa-user"></i>
                      </div>
                      <div class="title-data">
                        <div class="first-line">{{ client.name | titlecase }}</div>
                        <div class="second-line">RUT: {{ client.rut | identifier }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="orders">
                    @for (order of client.orders; track order.id; let last = $last) {
                      <div class="order-card"
                        [class.ended-at]="order.ended_at"
                        [class.completed-at]="order.completed_at && !order.ended_at"
                        [class.check-in-time]="order.check_in_time && !order.completed_at && !order.ended_at"
                        [class.booking-time]="order.booking_date && !order.check_in_time && !order.ended_at"
                        (click)="openOrder(order)"
                      >
    
                        <div class="icon">
                        @if (order.ended_at) {
                          <i class="fa fa-check-double"></i>
                        } @else if (order.completed_at && !order.ended_at) {
                          <i class="fa fa-check"></i>
                        } @else if (order.check_in_time && !order.completed_at) {
                          <i class="fa fa-wrench"></i>
                        } @else if (order.booking_date && !order.check_in_time && !order.ended_at) {
                          <i class="fa fa-clock"></i>
                        }
                        </div>
                        <div class="requirement">
                          <div>{{order.requirement?.name}}
                            
                          </div>
                        </div>
                        <div class="order-info">
                        <div>KMS: {{order.kms | currency:'':'':'0.0-0'}}</div>
                        @if (order.ended_at) {
                          <div>Entregado: {{order.ended_at | date:'shortDate'}}</div>
                        } @else if (order.completed_at && !order.ended_at) {
                          <div>Completado: {{order.completed_at | date:'shortDate'}}</div>
                        } @else if (order.check_in_time && !order.completed_at) {
                          <div>Ingresado: {{order.check_in_time | date:'shortDate'}}</div>
                        } @else if (order.booking_date && !order.check_in_time && !order.ended_at) {
                          <div>Agendado: {{order.booking_date | date:'shortDate'}}</div>
                        }
                        </div>
                      </div>
                    }
                  </div>
                </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (forbidden()) {
    <div class="no-access">
      <i class="fa fa-warning"></i>
      No tienes acceso a esta información
    </div>
  }
</div>
